import { unformatNumberBR } from 'src/utils'
import * as yup from 'yup'

const requiredField = 'Campo obrigatório!'
const greaterThanZero = 'Deve ser maior do que 0!'

const setUnitRequiredField = (unidade, actualSchema) => {
  if (unidade === 'UN') {
    return actualSchema.required(requiredField).min(0, greaterThanZero)
  }
}

export const getSchema = (validadeRequired, isFrozen = false) => {
  return yup.object().shape({
    codigoDeBarras: yup.string().required(requiredField),
    descricao: yup.string().required(requiredField),
    avulso: yup.number().when('unidade', setUnitRequiredField),
    caixaria: yup.number().when('unidade', setUnitRequiredField),
    qtdCaixas: yup.number().when('unidade', setUnitRequiredField),
    total: yup.number().transform((curr, orig) => unformatNumberBR(orig)),
    weight: yup
      .number()
      .transform((curr, orig) => unformatNumberBR(orig))
      .when('unidade', (unidade, actualSchema) => {
        if (unidade !== 'UN') {
          return actualSchema
            .min(0, 'Pesagem deve ser maior do que 0!')
            .notOneOf([0], 'Pesagem não deve ser 0!')
            .required(requiredField)
        }
      }),
    validade: yup
      .date()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .when([], {
        is: () => validadeRequired,
        then: (schema) => schema
          .required(requiredField),
        otherwise: (schema) => schema
          .default(null)
          .nullable(),
      }),
    tipoAvarias: yup.string().required(requiredField),
    quantidadeAvarias: yup
      .number()
      .transform((_, orig) => unformatNumberBR(orig))
      .required(requiredField)
      .min(0, 'Avaria deve ser no mínimo 0')
      .when('unidade', (unidade, actualSchema) => {
        if (unidade === 'UN') {
          return actualSchema
            .max(yup.ref('total'), 'A quantidade deve ser menor ou igual ao total')
        }
      })
      .when('unidade', (unidade, actualSchema) => {
        if (unidade === 'KG') {
          return actualSchema
            .max(yup.ref('weight'), 'A quantidade deve ser menor ou igual ao total')
        }
      })
      .when('tipoAvarias', (tipoAvarias, actualSchema) => {
        if (!tipoAvarias) {
          return actualSchema
        }

        if (['', 'NENHUM'].includes(tipoAvarias)) {
          return actualSchema.oneOf([0], 'Valor deve ser 0!')
        }
        return actualSchema.notOneOf([0], 'Valor não deve ser 0!')
      }),
    temperaturaItem: isFrozen 
      ? yup
          .number()
          .transform((curr, orig) => (orig === '' ? null : parseFloat(orig)))
          .required('Temperatura do produto é obrigatória para produtos congelados!')
          .min(-200, 'Temperatura deve estar entre -200°C e 200°C')
          .max(200, 'Temperatura deve estar entre -200°C e 200°C')
      : yup
          .number()
          .transform((curr, orig) => (orig === '' ? null : parseFloat(orig)))
          .nullable()
          .notRequired(),
  })
}
